import * as messages from './messages'
import * as requestTypes from './requestTypes'
import * as actions from '../actions'
import {Transaction, TransactionStatus} from '../data/Transaction'

export const createResponse = (request) => {
    switch (request.method) {
        case requestTypes.KEEPALIVE:
            return {}
    }

    return null
}

export const parseRequest = (request) => {
    switch (request.method) {
        case requestTypes.STATUS_EVENT:
            return actions.statusChanged(messages.statusResult(request.params))
        case requestTypes.POS_MESSAGE:
            return actions.displayMessageReceived(messages.displayMessage(request.params))
        default:
            return actions.receiveRawRequest(request)
    }
}

export const parseResponse = (request, response) => {
    switch (request.method) {
        case requestTypes.CHECK:
        case requestTypes.PURCHASE:
        case requestTypes.REFUND:
            return parseTransactionResponse(request, response)
        case requestTypes.STATUS:
            return actions.statusChanged(messages.statusResult(response.result), request)
        case requestTypes.TERMINAL_INFO:
            return actions.terminalInfoReceived(messages.terminalInfo(response.result), request)
        default:
            return actions.receiveRawResponse(response, request)
    }
}

const parseTransactionResponse = (request, response) => {
    const requestData = request.params ? request.params.external_data : null
    const requestTransaction = requestData ? new Transaction(requestData) : null

    if (requestTransaction && requestTransaction.id && requestTransaction.transactionType) {
        if (response.result) {
            if (response.result.response_code) {
                return actions.transactionCompleted(messages.transactionResult(requestData.id, requestData.transactionType, response.result), request)
            } else if (response.result.terminal_processing) {
                return actions.transactionProcessing(requestTransaction, request)
            }
        } else if (response.error) {
            if (response.error.data && response.error.data.response_code) {
                return actions.transactionCompleted(messages.transactionResult(requestData.id, requestData.transactionType, response.error.data, response.error), request)
            } else if (response.error.data && response.error.data.string_code === 'TRANSACTION_NOT_FOUND') {
                const missingTransaction = requestTransaction.set('status', TransactionStatus.MISSING)
                return actions.transactionCompleted(missingTransaction as Transaction, request)
            } else {
                const errorTransaction = requestTransaction
                    .set('errorCode', response.error.code)
                    .set('errorMessage', response.error.message)
                    .set('status', TransactionStatus.CLOSED)
                return actions.transactionCompleted(errorTransaction as Transaction, request)
            }
        }
    }

    return actions.receiveRawResponse(response, request)
}
